import { render } from "./component-inn.vue?vue&type=template&id=5720fd76"
import script from "./component-inn.vue?vue&type=script&setup=true&lang=js"
export * from "./component-inn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-inn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5720fd76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5720fd76', __exports__)) {
    api.reload('5720fd76', __exports__)
  }
  
  module.hot.accept("./component-inn.vue?vue&type=template&id=5720fd76", () => {
    api.rerender('5720fd76', render)
  })

}


export default __exports__